import { useGetFeaturesQuery } from "@/pages/Private/redux/feature/feature.api";

export const useIsFeatureActive = (featureName: string): boolean | undefined => {
	const { data: features, isLoading } = useGetFeaturesQuery();

	if (isLoading) {
		return undefined;
	}

	const feature = features?.find((f) => f.feature === featureName);

	return feature ? feature.active : false;
};
